document.addEventListener('DOMContentLoaded', function() {
  const dateElement = document.getElementById('scheduled-delivery-date-date');
  const limitElement = document.getElementById('scheduled-delivery-date-limit');
  
  if (!dateElement || !limitElement) {
    console.error('Required elements not found.');
    return;
  }

  const period = parseInt(dateElement.dataset.period, 10);
  if (isNaN(period)) {
    console.error('Invalid period value:', dateElement.dataset.period);
    return;
  }

  // holiday_jpライブラリがロードされているか確認
  if (typeof holiday_jp === 'undefined') {
    console.error('holiday_jp library is not loaded.');
    // 必要であれば、ここでライブラリのロードを待つ処理を追加することも検討できます。
    // 例えば、一定時間後に再試行するなど。
    return;
  }

  /**
   * 指定された日付からN営業日後の日付を計算します。
   * 土日と祝日を除外します。
   * @param {Date} startDate - 開始日
   * @param {number} businessDays - 営業日数
   * @returns {Date} - N営業日後の日付
   */
  function calculateBusinessDate(startDate, businessDays) {
    let currentDate = new Date(startDate);
    let addedDays = 0;

    while (addedDays < businessDays) {
      currentDate.setDate(currentDate.getDate() + 1);
      const dayOfWeek = currentDate.getDay(); // 0:日曜日, 6:土曜日
      const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
      const isHoliday = holiday_jp.isHoliday(currentDate);

      if (!isWeekend && !isHoliday) {
        addedDays++;
      }
    }
    return currentDate;
  }

  // 注文期限用の日時（現在時刻）
  const today = new Date();
  const orderLimitDate = new Date(today);
  
  // 12:00以降は翌日の午前0時を期限として設定
  if (today.getHours() >= 12) {
    orderLimitDate.setDate(today.getDate() + 1);
  }
  orderLimitDate.setHours(12, 0, 0, 0);

  // 到着予定日の計算
  const estimatedDeliveryDate = calculateBusinessDate(today, period);

  // 注文期限日時を YYYY年MM月DD日(曜日)HH:MM 形式でフォーマット
  const weekDays = ['日', '月', '火', '水', '木', '金', '土'];
  const limitYear = orderLimitDate.getFullYear();
  const limitMonth = (orderLimitDate.getMonth() + 1);
  const limitDay = orderLimitDate.getDate();
  const limitDayOfWeek = weekDays[orderLimitDate.getDay()];
  const limitHour = orderLimitDate.getHours();
  const limitMinute = orderLimitDate.getMinutes().toString().padStart(2, '0');
  
  const limitFormattedDate = `${limitYear}年<strong>${limitMonth}月${limitDay}日(${limitDayOfWeek})</strong>${limitHour}:${limitMinute}`;
  
  // 到着予定日を MM月DD日(曜日) 形式でフォーマット
  const estimatedMonth = (estimatedDeliveryDate.getMonth() + 1);
  const estimatedDay = estimatedDeliveryDate.getDate();
  const estimatedDayOfWeek = weekDays[estimatedDeliveryDate.getDay()];
  
  const estimatedFormattedDate = `<strong>${estimatedMonth}月${estimatedDay}日(${estimatedDayOfWeek})</strong>`;

  // 表示テキストを設定
  limitElement.innerHTML = `${limitFormattedDate}<br>までのご注文は`;
  dateElement.innerHTML = `${estimatedFormattedDate}<br>に到着予定です。`;
});
